// extracted by mini-css-extract-plugin
export default {"cls1":"UserTooltip-cls1__adcc16cce64b7624d05d","cls2":"UserTooltip-cls2__aeb324953c4ab7548b1e UserTooltip-cls1__adcc16cce64b7624d05d"};